import { render } from "./submissions-info-badges.vue?vue&type=template&id=38d0e09e&scoped=true&ts=true"
import script from "./submissions-info-badges.vue?vue&type=script&lang=ts"
export * from "./submissions-info-badges.vue?vue&type=script&lang=ts"

import "./submissions-info-badges.vue?vue&type=style&index=0&id=38d0e09e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d0e09e"]])

export default __exports__